<template>
  <b-row>
    <b-col
      v-for="step in getCrmStepsList.results"
      :key="step.id"
    >
      <b-card no-body>
        <b-card-body class="d-flex justify-content-between align-items-center">
          <div class="text-truncate">
            <h2 class="mb-50 font-weight-bolder">
              {{ currencyFormatter(step.step_statistics) }}
            </h2>
            <span :class="'text-' + step.color">{{ step.title[$i18n.locale] }}</span>
          </div>
          <b-avatar
            :variant="step.icon"
            size="45"
          >
            <feather-icon
              size="21"
              :icon="step.icon"
            />
          </b-avatar>
        </b-card-body>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow, BCol, BCard, BCardBody, BAvatar,
} from 'bootstrap-vue'
import { mapGetters } from 'vuex'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BAvatar,
  },
  computed: {
    ...mapGetters('kanban', ['getCrmStepsList']),
  },
  methods: {
    currencyFormatter(amount) {
      const dollarUSLocale = Intl.NumberFormat('ru-RU')
      return dollarUSLocale.format(amount)
    },
  },
}
</script>

<style lang="scss" scoped>

</style>
